// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1bQPT","footer":"ReportModalFilter_footer__E5n1F"};